import axios from 'axios'
import store from '@/store'

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api/' : 'https://www.vines.work/api/'
// const baseUrl = 'https://www.vines.work/api/'

// 响应拦截器
// axios.interceptors.response.use(
// 	response => {
// 		if (response.data.code === -201) {
// 			store.commit('delete_user')
// 			store.commit('update_headers', null)
// 		}
// 		// 对响应数据做点什么
// 		return response
// 	},
// 	error => {
// 		// 对响应错误做点什么
// 		// 可以根据错误状态码做不同的处理
// 		if (error.response) {
// 			// 根据错误状态码进行处理
// 		}
// 		return Promise.reject(error)
// 	}
// )

export const request = async (url = '', data = {}, type = 'GET', customHeader = {}, isCombine = true) => {
    type = type.toUpperCase()

    console.log(`向${url}提交${type}请求, params = ${JSON.stringify(data)}`)

    const combinedUrl = isCombine ? baseUrl + url : url

    const tokenExpired = () => {
        store.commit('delete_user')
        store.commit('update_headers', null)
        localStorage.removeItem('headers')
    }

    switch (type) {
        case 'GET': {
            let response = {}
            try {
                let headers = Object.assign({}, axios.defaults.headers.get, store.state.headers, customHeader)
                // console.log(`headers = ${JSON.stringify(headers)}`)
                response = await axios.get(combinedUrl, {params: data, headers: headers})
                if (response.data.code === -201) tokenExpired()
                if (response.status === 200) {
                    response = response.data
                }
            } catch (error) {
                console.log(error)
            }
            return response
        }
        case 'POST': {
            let response = {}
            try {
                let headers = Object.assign({},
                    axios.defaults.headers.post, store.state.headers,
                    customHeader)
                // console.log(`headers = ${JSON.stringify(headers)}`)
                response = await axios.post(combinedUrl, data, {params: data, headers: headers})
                if (response.data.code === -201) tokenExpired()
                if (response.status === 200) {
                    response = response.data
                }
            } catch (error) {
                console.log(error)
            }
            return response
        }
        case 'UPLOAD': {
            let response = {}
            try {
                let headers = Object.assign({}, axios.defaults.headers.post, store.state.headers, customHeader)
                response = await axios.post(combinedUrl, data, {headers: headers})
                if (response.data.code === -201) tokenExpired()
                if (response.status === 200) {
                    response = response.data
                }
            } catch (error) {
                console.log(error)
            }
            return response
        }
        case 'DOWNLOAD': {
            let response = {}
            try {
                const link = document.createElement('a')
                link.href = combinedUrl
                link.download = data?.name ?? ''
                link.target = '_blank'           // 兜底，跨域时浏览器会新开/直接下载
                link.rel = 'noopener noreferrer'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            } catch (error) {
                console.log(error)
            }
            return response
        }
    }
}
